export const TEXT_TYPE = {
  TEXT: 'Text',
  HEADING: 'Heading',
}